
import { defineComponent } from 'vue'
import ModalDialog from './ModalDialog.vue'
import PrimaryButton from '../buttons/PrimaryButton.vue'
import Loader from '../Loader.vue'
import { DeleteIcon } from '@/components/icons'
import { AlertType } from '@/enums'
import moment from 'moment'

export default defineComponent({
  name: 'DeleteClockinInDialog',

  emits: ['close', 'reload'],

  components: {
    ModalDialog, PrimaryButton, Loader, DeleteIcon
  },

  props: {
    clockingInId: { type: String, required: true },
    userId: { type: String, required: true },
    date: { type: String, required: true }
  },

  data: function () {
    return {
      loading: false,
      moment
    }
  },

  methods: {
    deleteClockingIn: async function () {
      try {
        const result = await this.$store.dispatch(
          'clockingIns/deleteClockingIn',
          { clockingInId: this.clockingInId, userId: this.userId }
        )

        this.loading = false
        if (!result) {
          await this.$store.dispatch('alerts/create', {
            message: 'eliminazione timbratura fallita',
            type: AlertType.error
          })
          return
        }

        await this.$store.dispatch('alerts/create', {
          message: 'eliminazione timbratura riuscita',
          type: AlertType.success
        })

        this.$emit('close')
        this.$emit('reload')
      } catch (error) {
        console.error('error deleting the clocking', error)
        this.loading = false
        await this.$store.dispatch('alerts/create', {
          message: 'eliminazione blocco fallita',
          type: AlertType.error
        })
      }
    }
  }
})
